import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

export const OffboardPopupContext = createContext();

export function useOffboardPopupContext(){
    return useContext(OffboardPopupContext);
}

export const OffboardPopupContextProvider = ({ children }) => {
    const [isExitOpen, setExitOpen] = useState(false);
     // to observe state changes
     useEffect(() => {
    }, [isExitOpen]);

    // Toggle popup function
    const toggleExitPopup = (isOpen) => {
        setExitOpen(isOpen);
    };

    const contextValue = useMemo(() => ({ 
        isExitOpen, 
        toggleExitPopup, 
        setExitOpen 
    }), [isExitOpen]);

    return (
        <OffboardPopupContext.Provider value={{ contextValue }}>
            {children}
        </OffboardPopupContext.Provider>

    )
};

OffboardPopupContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

